module.exports = __webpack_public_path__ + "static/img/two.ce9f8067.png";